import { render } from "./SearchEvents.vue?vue&type=template&id=a90a3d7e"
import script from "./SearchEvents.vue?vue&type=script&lang=js"
export * from "./SearchEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__